var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pointer-events-none absolute bottom-0 bg-gradient-to-b from-transparent to-dark"})
}
var staticRenderFns = []

export { render, staticRenderFns }